import { render, staticRenderFns } from "./ModelInterests.vue?vue&type=template&id=2e27ffcf&scoped=true&"
import script from "./ModelInterests.vue?vue&type=script&lang=js&"
export * from "./ModelInterests.vue?vue&type=script&lang=js&"
import style0 from "./ModelInterests.vue?vue&type=style&index=0&id=2e27ffcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27ffcf",
  null
  
)

export default component.exports